<script>
    import { orderFormStore } from "$lib/stores/store";
    import { typeToEnglish } from "$lib/utils/typesToEnglish";
    import { RadioGroup, RadioItem } from "@skeletonlabs/skeleton";
    import { certificationPricingStore } from "$lib/stores/store";

    let formattedTotalPrice;
    let order_type_id = $orderFormStore.order_type;
    $: if ($orderFormStore.isAnnually && $orderFormStore.order_type !== "") {
        formattedTotalPrice = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format($orderFormStore.certificationPriceInCents / 100);
    } else {
        formattedTotalPrice = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format($orderFormStore.certificationPriceInCents / 100);
    }

    function onCadenceToggle() {
        if ($orderFormStore.isAnnually === true) {
            console.log("paying annually");
            $orderFormStore.stripe_price_id = certificationPricingStore[order_type_id].stripe_id_annual;
            $orderFormStore.certificationPriceInCents = certificationPricingStore[order_type_id].cents_annually;
        } else if ($orderFormStore.isAnnually === false) {
            console.log("paying monthly");

            $orderFormStore.stripe_price_id = certificationPricingStore[order_type_id].stripe_id_monthly;
            $orderFormStore.certificationPriceInCents = certificationPricingStore[order_type_id].cents_monthly;
        }
    }
</script>

<div class="order-summary-wrapper card-container flex flex-col gap-4">
    <div class="header flex flex-col text-left">
        <h2 class="text-2xl font-bold pb-2">Order Summary</h2>
        {#if $orderFormStore.vehicle_year && $orderFormStore.vehicle_make && $orderFormStore.vehicle_model}
            <p>{$orderFormStore.vehicle_year} {$orderFormStore.vehicle_make} {$orderFormStore.vehicle_model}</p>
        {/if}
    </div>
    <div class="divider"></div>
    <div class="line-item-wrapper">
        <!-- <div class="line-grid-item">
            <span>Vehicle Inspection</span>
            <span class="text-gray-600 font-thin text-md">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(0.0)} </span>
        </div> -->

        <div class="line-grid-item">
            <span>{typeToEnglish[$orderFormStore.order_type]} Membership </span>
            <span>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format($orderFormStore.certificationPriceInCents / 100)}</span>
        </div>
    </div>
    <div class="divider"></div>
    <div class="pay-term">
        <RadioGroup class="w-full relative" active="variant-filled-surface bg-surface-800 text-white" hover="hover:variant-soft-primary">
            <div class="relative flex flex-row w-full">
                <RadioItem name="order-type" class="text-md font-semibold" bind:group={$orderFormStore.isAnnually} on:change={onCadenceToggle} value={false}>Monthly</RadioItem>
            </div>
            <div class="relative flex flex-row w-full">
                <span class="text-sm font-normal absolute -top-4 right-0 z-10 bg-primary-500 text-white px-2 py-1 rounded-xl">Save</span>
                <RadioItem name="order-type" class="text-md font-semibold" bind:group={$orderFormStore.isAnnually} on:change={onCadenceToggle} value={true}>Annually</RadioItem>
            </div>
        </RadioGroup>
    </div>

    <div class="total-line">
        <span class="bold-text">Total Due Today</span>
        <span>{formattedTotalPrice}</span>
    </div>

    <slot></slot>
</div>

<style>
    .order-summary-wrapper {
        display: flex;
        width: 411px;
        padding: 50px var(--Spacing-10, 40px);
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
    }
    .card-container {
        border-radius: 20px;
        background: #fff;
    }
    .header {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 5px;
        align-self: stretch;
    }
    .header > h2 {
        width: 100%;
    }
    .divider {
        max-height: 1px !important;
        min-height: 1px !important;
        width: 100%;
        display: block;
        margin: 2.5px 0;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
        background-color: #e7e6e6;
    }
    .line-item-wrapper {
        display: flex;
        height: 58px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: var(--Spacing-25, 10px);
        align-self: stretch;
    }
    .line-grid-item {
        display: flex;
        height: 40px;
        padding: 5px;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
    }
    .pay-term {
        display: flex;
        height: 40px;
        padding: 5px;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
    }
    .total-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
    }
    .total-line > span {
        color: #000;

        /* label 3/label 3 semibold */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
    }
    .bold-text {
        font-weight: 600;
    }
</style>
